import {Ventrata} from 'types'
import {ga4} from 'utils/ga4'
import {getBookingByUuid} from 'utils/getBookingById'
import {getCurrency} from 'utils/getCurrency'
import {getGa4BookingItems} from 'utils/getGa4BookingItems'
import {getHumanPrice} from 'utils/getHumanPrice'

type Params = {
  order: Ventrata.Order
  bookingUuid: string
  crossSellingFlag: boolean
}

export const addToCart = ({order, bookingUuid, crossSellingFlag}: Params) => {
  const booking = getBookingByUuid(order, bookingUuid)
  const currency = getCurrency(order)

  ga4({
    event: 'add_to_cart',
    ecommerce: {
      currency,
      value: getHumanPrice(booking.pricing?.retail),
      checkout_type: 'custom_checkout',
      items: getGa4BookingItems(booking, currency, crossSellingFlag),
    },
  })
}
